export default "__VITE_ASSET__e60fff38__"